module.exports = __webpack_public_path__ + "static/lightning-select-32bea2fb042994afe15218c7e616ad60.png";